import { Icon, IconButton, Snackbar, Typography } from "@material-ui/core"
import { EmailList, DocumentReportTypePicker } from "components"
import { useDocumentReportParams } from "hooks"
import {
  ROOT_TITLE,
  SEND_REPORT_TITLE,
  transformDocumentReportParams,
  sendDocumentReportByEmailService,
} from "lib"
import React from "react"
import { Helmet } from "react-helmet"
import Lottie from "react-lottie"
import mailSend from "assets/animations/mail-send.json"
import { Alert } from "@material-ui/lab"
import ReportReceivedTypePicker from "components/DocumentReceivedReportTypePicker/DocumentReceivedReportTypePicker"
import useReceivedReportParams from "hooks/report/useDocumentReceivedReportParams"
import { generateReportService } from "lib/utils/api/report_received"
import { TypeReportReceived } from "lib/enums/reportType.enum"
import { ReceivedReportRequest } from "types/request/ReceivedReportRequest"

const DocumentReceivedReports = () => {
  const [selected, setSelected] = React.useState<TypeReportReceived[]>([])
  const { handleChangeParams, params } = useReceivedReportParams()
  const [open, setOpen] = React.useState(false)

  const toggleSelect = (type: TypeReportReceived) => {
    setSelected((current) =>
      current.includes(type)
        ? current.filter((c) => c !== type)
        : [...current, type],
    )
  }

  const onSubmit = async (emails: string[]) => {
    try {
      setSelected([])
      const response = await generateReportService({
        emails,
        reportTypes: selected,
        simple: params.simple,
        accounting: params.accounting,
      } as ReceivedReportRequest)
      if (response.status === 200) {
        setOpen(true)
      }
    } catch (error) {
      console.log("Error",error)
    }
  }
  return (
    <div className="w-full flex flex-col h-full overflow-hidden">
      <Helmet>
        <title>{`${ROOT_TITLE} - ${SEND_REPORT_TITLE}`}</title>
      </Helmet>
      <div className="flex flex-grow overflow-hidden">
        <ReportReceivedTypePicker
          selected={selected}
          toggleSelect={toggleSelect}
          onChange={handleChangeParams}
          params={params}
        />
        <EmailList
          reportTypeSelected={Boolean(selected.length)}
          onSubmit={onSubmit}
        />
      </div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
        action={
          <IconButton
            style={{ marginRight: 20 }}
            aria-label="close"
            color="inherit"
            onClick={() => setOpen(false)}
          >
            <Icon>close</Icon>
          </IconButton>
        }
      >
        <Alert
          variant="filled"
          onClose={() => setOpen(false)}
          severity="info"
          style={{ paddingRight: 30 }}
        >
          <div className="flex items-center">
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: mailSend,
                rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
              }}
              height={120}
              width={120}
            />
            <Typography className="px-4">
              {"Sus reportes se estan enviando..."}
            </Typography>
          </div>
        </Alert>
      </Snackbar>
    </div>
  )
}

export default DocumentReceivedReports
